import { Model } from '@nozbe/watermelondb';
import { field } from '@nozbe/watermelondb/decorators';

function parseJsonObject(value: string): Record<string, unknown> {
  if (!value) return {};
  try {
    const parsed = JSON.parse(value);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed;
    }
    return {};
  } catch {
    return {};
  }
}

export default class DemoSaleInformation extends Model {
  static table = 'demo_sales_information';

  @field('bp_employee_id') bpEmployeeId!: string;
  @field('bp_owner_id') bpOwnerId!: string;
  @field('bp_order_id') bpOrderId!: string;
  @field('bp_product_id') bpProductId!: string;
  @field('bp_order_quantity') bpOrderQuantity!: number;
  @field('bp_order_price') bpOrderPrice!: number;
  @field('bp_order_paid_quantity') bpOrderPaidQuantity!: number;
  @field('bp_order_completed') bpOrderCompleted!: boolean;
  @field('bp_order_partial_paid') bpOrderPartialPaid!: boolean;
  @field('bp_order_created_at') bpOrderCreatedAt!: number;
  @field('bp_order_updated_at') bpOrderUpdatedAt!: number;
  @field('bp_order_deleted_at') bpOrderDeletedAt!: number;
  @field('bp_order_mass') bpOrderMass!: number;
  @field('bp_order_paid_mass') bpOrderPaidMass!: number;
  @field('bp_sales_location_id') bpSalesLocationId!: string;
  @field('bp_selling_price_changed') bpSellingPriceChanged!: boolean;
  @field('bp_product_information') bpProductInformation!: string;
  @field('bp_order_price_type') bpOrderPriceType!: string;

  get productInformation() {
    return parseJsonObject(this.bpProductInformation);
  }

  toSalesObject() {
    return {
      bp_sales_id: this.id,
      bp_employee_id: this.bpEmployeeId,
      bp_owner_id: this.bpOwnerId,
      bp_order_id: this.bpOrderId,
      bp_product_id: this.bpProductId,
      bp_order_quantity: this.bpOrderQuantity,
      bp_order_price: this.bpOrderPrice,
      bp_order_paid_quantity: this.bpOrderPaidQuantity,
      bp_order_completed: this.bpOrderCompleted,
      bp_order_partial_paid: this.bpOrderPartialPaid,
      bp_order_created_at: this.bpOrderCreatedAt,
      bp_order_updated_at: this.bpOrderUpdatedAt,
      bp_order_deleted_at: this.bpOrderDeletedAt,
      bp_order_mass: this.bpOrderMass,
      bp_order_paid_mass: this.bpOrderPaidMass,
      bp_sales_location_id: this.bpSalesLocationId,
      bp_selling_price_changed: this.bpSellingPriceChanged,
      bp_order_price_type: this.bpOrderPriceType,
      bp_product_information: this.productInformation,
    };
  }
}
